var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    transform: "rotate(90 39 1)",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 20.2268L13.4596 20.2268L14.3132 21.0804L17.7236 24.4908L18.0771 24.1372L17.7236 24.4908C17.8121 24.5793 17.8121 24.7229 17.7236 24.8114C17.6351 24.8999 17.4914 24.8999 17.4029 24.8114L12.752 20.1605C12.6634 20.0719 12.6634 19.9284 12.752 19.8398L12.3984 19.4863L12.752 19.8398L17.4027 15.189C17.4472 15.1445 17.5045 15.1224 17.5631 15.1224C17.6218 15.1224 17.6791 15.1445 17.7235 15.1888C17.812 15.2774 17.812 15.4209 17.7235 15.5095L17.7235 15.5095L14.3132 18.9199L13.4597 19.7734L14.6667 19.7734L27.088 19.7734C27.2131 19.7734 27.3147 19.875 27.3147 20.0001C27.3147 20.1253 27.2132 20.2268 27.088 20.2268L14.6667 20.2268Z",
    fill: "black",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/BackBtn.a1a4ed82f708a9fb62c2d7252b6e0cc3.svg";
export { ForwardRef as ReactComponent };